export default "/fonts/vendor/mdui/dist/roboto/Roboto-MediumItalic.woff?8be651082cc0d07c84f633965e8ced59";